import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { ContractSettings } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const contractSettingsUrl = `${environment.apiUrl}/contractsettings`;
const contractSettingsDetailUrl = contractId => `${environment.apiUrl}/contractsettingsdetail/${contractId}`;

@Injectable()
export class ContractSettingsService {
  constructor(private readonly httpService: HttpService) {}

  getAllContractSettings(): Observable<ContractSettings[]> {
    return this.httpService.get<ContractSettings[]>(contractSettingsUrl);
  }

  createContractSettings(contractSettings: ContractSettings): Observable<ContractSettings> {
    return this.httpService.post(contractSettingsUrl, contractSettings);
  }

  updateContractSettings(contractSettings: ContractSettings): Observable<ContractSettings> {
    return this.httpService
      .put(contractSettingsDetailUrl(contractSettings.contractId), contractSettings)
      .map(response => response.json() as ContractSettings);
  }

  deleteContractSettings(id: number): Observable<ContractSettings> {
    return this.httpService.delete(contractSettingsDetailUrl(id)).map(response => response.json() as ContractSettings);
  }

  getContractSettings(id: number): Observable<ContractSettings> {
    return this.httpService.get<ContractSettings>(contractSettingsDetailUrl(id));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contract.settings.service.ts